export default [
  { value: 1, label: '图片' },
  { value: 2, label: 'PDF文件' },
]